(ns hypnos.backoffice.tile.field.anatomy-pixels
  "Fields for the pixels."
  (:require [clojure.string :as str]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Calculation

(defn- calc
  "Calculates the metric value based on the (iris) reference value (in pixels)."
  [iris v]
  (when (and iris v (> iris 0))
    (Math/round (* (/ 12 iris) v))))

(defn- recalc-values
  "Re-calculate the state values."
  [state]
  (when-let [iris (get-in @state [:pixels :anatomy/iris-diameter])]
    (swap! state assoc-in [:anatomy :anatomy/head-height] (calc iris (get-in @state [:pixels :anatomy/head-height])))
    (swap! state assoc-in [:anatomy :anatomy/head-width] (calc iris (get-in @state [:pixels :anatomy/head-width])))
    (swap! state assoc-in [:anatomy :anatomy/nose-width] (calc iris (get-in @state [:pixels :anatomy/nose-width])))
    (swap! state assoc-in [:anatomy :anatomy/nose-length] (calc iris (get-in @state [:pixels :anatomy/nose-length])))
    (swap! state assoc-in [:anatomy :anatomy/nose-to-clef] (calc iris (get-in @state [:pixels :anatomy/nose-to-clef])))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn iris-field
  ([state]
   (iris-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/iris)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/diameter)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 3
          :disabled   disabled
          :value      (when-let [val (get-in @state [:pixels :anatomy/iris-diameter])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in [:pixels :anatomy/iris-diameter] new-value)
                          (recalc-values state)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/px)]]]]]]))

(defn head-field
  ([state]
   (head-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/head)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/height)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       4
          :width      4
          :max-length 4
          :disabled   disabled
          :value      (when-let [val (get-in @state [:pixels :anatomy/head-height])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in [:pixels :anatomy/head-height] new-value)
                          (recalc-values state)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/px)]]]]
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/width)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       4
          :width      4
          :max-length 4
          :disabled   disabled
          :value      (when-let [val (get-in @state [:pixels :anatomy/head-width])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in [:pixels :anatomy/head-width] new-value)
                          (recalc-values state)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/px)]]]]]]))

(defn nose-field
  ([state]
   (nose-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/nose)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/width)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       4
          :width      4
          :max-length 4
          :disabled   disabled
          :value      (when-let [val (get-in @state [:pixels :anatomy/nose-width])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in [:pixels :anatomy/nose-width] new-value)
                          (recalc-values state)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/px)]]]]
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/length)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       4
          :width      4
          :max-length 4
          :disabled   disabled
          :value      (when-let [val (get-in @state [:pixels :anatomy/nose-length])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in [:pixels :anatomy/nose-length] new-value)
                          (recalc-values state)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/px)]]]]]]))

(defn nare-clef-field
  ([state]
   (nare-clef-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal]
    [:div.field-body
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/nose-to-clef)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       4
          :width      4
          :max-length 4
          :disabled   disabled
          :value      (when-let [val (get-in @state [:pixels :anatomy/nose-to-clef])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in [:pixels :anatomy/nose-to-clef] new-value)
                          (recalc-values state)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/px)]]]]]]))
